import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function AnimatedCheckMark({ classes }) {
  const styles = useStyles();
  const iconClasses = cn(styles.animatedCheck, classes);

  return (
    <svg className={iconClasses} version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
      <circle className={styles.circle} fill="none" strokeWidth="6" strokeMiterlimit="10" cx="65.1" cy="65.1" r="62.1" />
      <polyline className={styles.check} fill="none" strokeWidth="6" strokeLinecap="round" strokeMiterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
    </svg>
  );
}

AnimatedCheckMark.propTypes = {
  classes: PropTypes.string,
};

AnimatedCheckMark.defaultProps = {
  classes: '',
};

export default AnimatedCheckMark;
